// extracted by mini-css-extract-plugin
export default {"container":"audio__container__hg_Ts","muted":"audio__muted__PFLRV","soundOn":"audio__soundOn__RJ9TU","hide":"audio__hide__QuLdZ"};